import {
    kilogramsPerHectareToPoundsPerAcre,
    poundsPerAcreToKilogramsPerHectare
} from 'utils/applicationRateUtil';

import { VerticalContainer } from '@american-autonomy/ag-ui';

import StepperField from 'components/StepperField';

import {
    LABELS,
    SPREAD_RATE,
    SPREAD_RATE_METRIC_MAX,
    TURNTABLE_PERCENTAGE
} from 'pages/ApplicationDetailsPage/components/FlightPlannerPanel/components/SpraySettingsSection/constants';

import { TEST_ID } from './constants';
import type { FunctionComponent, NumericChangeParams, Props } from './types';

import styles from './styles.module.scss';

const SpreadSpecificFields: FunctionComponent<Props> = ({
    className = '',
    onChange,
    rateKilogramsPerHectare,
    testId = TEST_ID,
    turntablePercentage
}) => {
    const handleRateChange = ({ value }: NumericChangeParams) => {
        const metric = Math.min(poundsPerAcreToKilogramsPerHectare(value), SPREAD_RATE_METRIC_MAX);

        onChange({ spraySettings: { rateKilogramsPerHectare: metric } });
    };

    const handleTurntableChange = ({ value }: NumericChangeParams) => {
        onChange({ spraySettings: { turntablePercentage: value } });
    };

    return (
        <VerticalContainer
            className={`${className} ${styles.spreadSpecificFields}`}
            testId={testId}>
            <StepperField
                label={LABELS.spreadRate}
                max={SPREAD_RATE.max}
                min={SPREAD_RATE.min}
                onChange={handleRateChange}
                step={SPREAD_RATE.step}
                value={kilogramsPerHectareToPoundsPerAcre(rateKilogramsPerHectare)}
            />

            <StepperField
                label={LABELS.turntablePercentage}
                max={TURNTABLE_PERCENTAGE.max}
                min={TURNTABLE_PERCENTAGE.min}
                onChange={handleTurntableChange}
                step={TURNTABLE_PERCENTAGE.step}
                value={turntablePercentage}
            />
        </VerticalContainer>
    );
};

export default SpreadSpecificFields;
